import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import {
	ShouldNavigateHandlerSymbol,
	Router as RouterSymbol,
	UrlHistoryManagerSymbol,
	RoutingLinkUtilsAPISymbol,
	CommonNavigationClickHandlerSymbol,
	RouterContextSymbol,
	RoutingValidationSymbol,
	PageNumberSymbol,
	CustomPageContextSymbol,
	queryParamsWhitelistSymbol,
} from '../symbols'
import {
	LifeCycle,
	CurrentRouteInfoSymbol,
	NavigationClickHandlerSymbol,
	SamePageUrlChangeListenerSymbol,
	PagesMapSymbol,
} from '@wix/thunderbolt-symbols'
import { ShouldNavigateHandler } from './dsShouldNavigateHandler'
import { NavigationClickHandler } from './dsNavigationClickHandler'
import { RouterContext } from './dsRouterContext'
import { RoutingValidation } from './dsRoutingValidation'
import { PageRouteChangedHandler } from './dsPageRouteChangedHandler'
import { Router } from '../router'
import { CurrentRouteInfo } from '../currentRouteInfo'
import { RoutingLinkUtilsAPI } from '../routingLinkUtilsAPI'
import { CommonNavigationClickHandler } from '../commonNavigationClickHandler'
import { UrlHistoryManager, UrlChangeListener } from '../urlManager'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { PageNumberHandler } from '../pageNumber'
import { PagesMap } from '../pagesMap'
import { queryParamsWhitelistHandler } from './dsQueryParamsWhitelistHandler'

export const editor: ContainerModuleLoader = (bind) => {
	bind(RouterSymbol).to(Router)
	bind(CurrentRouteInfoSymbol).to(CurrentRouteInfo)
	bind(SamePageUrlChangeListenerSymbol).to(UrlChangeListener)
	bind(UrlHistoryManagerSymbol, LifeCycle.AppWillLoadPageHandler).to(UrlHistoryManager)
	bind(RoutingLinkUtilsAPISymbol).to(RoutingLinkUtilsAPI)
	bind(RouterContextSymbol, CustomPageContextSymbol).to(RouterContext)
	bind(RoutingValidationSymbol).to(RoutingValidation)
	bind(NavigationClickHandlerSymbol).to(NavigationClickHandler)
	bind(ShouldNavigateHandlerSymbol).to(ShouldNavigateHandler)
	bind(CommonNavigationClickHandlerSymbol).to(CommonNavigationClickHandler)
	bind(ModelUpdatesHandlersImplementor).to(PageRouteChangedHandler)
	bind(PageNumberSymbol, LifeCycle.AppWillLoadPageHandler).to(PageNumberHandler)
	bind(PagesMapSymbol).to(PagesMap)
	bind(queryParamsWhitelistSymbol).to(queryParamsWhitelistHandler)
}
